import {
  getConsoleSink,
  type LoggerConfig,
  type Sink,
} from "@logtape/logtape";
import { emfFormatter } from "~/lib/emf";
import { IS_DEV } from "~/consts/env";

export const getEventSink = (): Sink =>
  IS_DEV ? () => {} : getConsoleSink({ formatter: emfFormatter });

export const loggers: LoggerConfig<"console" | "event", string>[] = [
  { category: ["app"], sinks: ["console"], lowestLevel: "debug" },
  {
    category: ["app", "event"],
    sinks: ["event"],
    parentSinks: "override",
    lowestLevel: "debug",
  },
  { category: ["logtape", "meta"], sinks: ["console"], lowestLevel: "warning" },
];
